import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getCompanies, getTypeOfTenders, getWorks } from 'ducks/options'
import { getHrmsMembers } from 'ducks/member'
import { getProjectByCompany } from 'ducks/goa'
import { GeneralInformationContainer } from './styled'

import r from 'reactotron-react-js'

const GeneralInformation = (props) => {
  const { valueForm, members, change, companies, projects, projectLoading, 
    typeOfTenders, works, isDisplay=false, isDetail } = props
  const [showGeneralInfo, setShowGeneralInfo] = useState(true)
    
  useEffect(() => {
    // if (!members.data.length && !members.loading) {
    //   props.getHrmsMembers()
    // }
    props.getHrmsMembers(isDetail)

    if (!companies.data.length && !companies.loading) {
      props.getCompanies()
    }

    if (!typeOfTenders.data.length && !typeOfTenders.loading) {
      props.getTypeOfTenders()
    }

    if (!works.data.length && !works.loading) {
      props.getWorks()
    }
  }, [])

  useEffect(() => {
    if (valueForm.companyCode) {
      if (projects[valueForm.companyCode] === undefined) {
        if (valueForm.companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(valueForm.companyCode)
        }
      }
    }
  }, [valueForm.companyCode])

  const memberOptions = members.data.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))
  const requesterOptions = members.data.filter(m => m.jobLevel >= 6).map(m => 
    ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` })
  )
  const workOptions = works.data.filter(w => w.tenderType === valueForm.typeOfTender) || []

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const projectOptions = () => {
    let projectOptions = []
    if (valueForm.companyCode && projects && projects[valueForm.companyCode]) {
      projectOptions = projects[valueForm.companyCode].map(p => { 
        return { value: p.id, text: p.projectName } 
      })

      if (projects.other) {
        projects.other.forEach(p => { 
          projectOptions.push({ value: p.id, text: p.projectName })
        })
      }
    }

    return projectOptions
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='General Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowGeneralInfo(!showGeneralInfo) }>
            {showGeneralInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showGeneralInfo}>
        <CardContent>
          <GeneralInformationContainer>
            <div className='rowFields'>
              <Field name='title' label='Title' require editable={editableForm()} type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='documentDate' 
                label='Document Date'
                editable={false}  
                type={type.date} 
                component={FieldInput} 
              />
              <Field 
                name='documentNumber' 
                label='Document Number'
                editable={false}  
                type={type.text} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='companyCode' 
                label='Company' 
                require
                editable={editableForm()}
                loading={companies.loading}
                options={companies.data} 
                type={type.select}
                specialOnChange={(value => {
                  if (value) {
                    if (projects[value] === undefined) {
                      if (value !== props.projectCompanyLoading) {
                        props.getProjectByCompany(value)
                      }
                    }
                  }
                })}
                component={FieldInput} />
              <Field 
                name='projectId' 
                label='Project' 
                require
                editable={editableForm()}
                loading={projectLoading}
                options={projectOptions()} 
                specialOnChange={(value) => {
                  var x = projectOptions().find(y => y.value === value)

                  if (x) {
                    change('projectName', x.text)
                  }
                }}
                type={type.select}
                component={FieldInput}
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='typeOfTender' 
                label='Type of Tender' 
                require
                editable={editableForm()}
                loading={typeOfTenders.loading}
                options={typeOfTenders.data} 
                type={type.select}
                component={FieldInput} />
              <Field 
                name='works' 
                label='Works' 
                require
                multiple={true}
                editable={editableForm()}
                loading={works.loading}
                options={workOptions} 
                type={type.select}
                component={FieldInput}
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='requesterUser' 
                label='Requester (PM-Level 6 Up)' 
                require
                editable={editableForm()}
                loading={members.loading}
                options={requesterOptions} 
                type={type.select}
                component={FieldInput} />
              <Field 
                name='createdBy' 
                label='Creator' 
                require
                editable={false}
                loading={members.loading}
                options={memberOptions} 
                type={type.select}
                component={FieldInput}
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='effectiveDate' 
                label='วันที่ต้องการใช้สินค้า/เริ่มงาน'
                require
                editable={editableForm()}  
                type={type.date} 
                component={FieldInput} 
              />
              <Field 
                name='draftBudget' 
                label='Draft Budget'
                require
                editable={editableForm()}
                type={type.number} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='projectStartTime' 
                label='วันที่เริ่มต้นของโครงการ'
                require
                editable={editableForm()}  
                type={type.date} 
                component={FieldInput} 
              />
              <Field 
                name='projectEndTime' 
                label='วันที่สิ้นสุดของโครงการ'
                require
                editable={editableForm()}  
                type={type.date} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='remark' 
                label='Remark' 
                editable={editableForm()} 
                type={type.textArea} 
                component={FieldInput} 
              />
            </div>
          </GeneralInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    members: { data: state.member.members, loading: state.member.memberLoading },
    companies: state.options.companies,
    projects: state.goa.projects,
    projectCompanyLoading: state.goa.projectCompanyLoading,
    projectLoading: state.goa.projectLoading,
    typeOfTenders: state.options.typeOfTenders,
    works: state.options.works,
  })
}
  

const mapDispatchToProps = {
  getHrmsMembers,
  getCompanies,
  getProjectByCompany,
  getTypeOfTenders,
  getWorks
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)